import type { ReactNode } from "react";

import { NvHeroPictogram } from "@/components/navigator/nv-icons-internal";
import { cn } from "@/lib/utils";

import { DETAIL_GUTTER } from "./detail-parts";

// 내부 Asset 상세 공통 조각 (Figma ver.7 03-09~12): 내용 폭 1136(좌우 152), 섹션 제목 40/400, 섹션 사이 100, 제목 아래 간격은 섹션마다 달라요.

export const PWC_LOGO = "/images/logos/logo-pwc-footer.svg";

// 보라 `내부 전용` 태그 (Figma 내부 전용 태그 55 x 15, r4)
export function InternalTag({ className }: { className?: string }) {
  return <span className={cn("inline-flex h-[15px] shrink-0 items-center rounded-[4px] bg-nv-purple-subtle px-[6px] text-[11px] font-bold leading-[13px] text-nv-purple", className)}>내부 전용</span>;
}

export function InternalSection({
  id,
  title,
  tag,
  aside,
  gap = 40,
  className,
  children,
}: {
  id: string;
  title: ReactNode;
  tag?: boolean;
  aside?: ReactNode;
  gap?: number;
  className?: string;
  children: ReactNode;
}) {
  return (
    <section id={`agent-${id}`} className={cn(DETAIL_GUTTER, "scroll-mt-[136px] break-keep pt-[72px] xl:pt-[100px]", className)}>
      <h2 className="flex flex-wrap items-baseline gap-x-[13px] text-[32px] font-normal leading-[40px] text-nv-text-primary xl:text-[40px] xl:leading-[48px]">
        {title}
        {tag && <InternalTag className="self-center" />}
        {aside && <span className="text-[14px] font-normal leading-[22px] text-nv-text-tertiary">{aside}</span>}
      </h2>
      <div style={{ marginTop: gap }}>{children}</div>
    </section>
  );
}

// 섹션 안 작은 제목 (18/500 · 17/500 …)
export function SubHeading({ children, className }: { children: ReactNode; className?: string }) {
  return <h3 className={cn("text-[18px] font-medium leading-[26px] text-nv-text-primary", className)}>{children}</h3>;
}

// 대표 이미지(4:3, 없을 때 기본형)의 정사각 픽토그램 타일: 시안 `대표 이미지 (1:1, 픽토그램만)` #F7F3EF r11~12
export function PictoTile({ size = 56, className }: { size?: number; className?: string }) {
  return (
    <span aria-hidden className={cn("flex shrink-0 items-center justify-center rounded-[12px] bg-[#F7F3EF]", className)} style={{ width: size, height: size }}>
      <NvHeroPictogram width={Math.round(size * 0.58)} height={Math.round(size * 0.54)} />
    </span>
  );
}

export function PwcMark({ width, className }: { width: number; className?: string }) {
  return <img src={PWC_LOGO} alt="PwC" width={width} height={Math.round(width / 2.02)} className={className} />;
}
